import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import {
  LanguageRow,
  LanguageColumn,
  SecurePaymentColumn,
  CookieRow,
  SocialColumn,
  SocialIcon,
  FootRow,
  FootRowInner,
  FootTextColumn,
  FootLinkText,
  FullWidthRow,
  RelxGroup,
  Wordmark,
  WordmarkColumn,
  BeianIco,
  AddressRow,
} from './_styled/footer.styled'
import Text from '../primitives/text'
import Line from '../primitives/line'
import SecurePayment from './secure-payment'
import getLink from '../../config/urls'

const Footer = ({ socials, support, content, t }) =>
  // removed ilustration service from footer links
  // const servicesList = services.concat(pages)
    (
      <>
        <FullWidthRow wide>
          <SecurePaymentColumn width={1}>
            <SecurePayment title={t('securePayment')} />
          </SecurePaymentColumn>
          <Line />
        </FullWidthRow>
        <FullWidthRow wide>
          <Line />
        </FullWidthRow>
        <LanguageRow wide>
          <LanguageColumn width={[6 / 12, 6 / 12]} />
          <SocialColumn width={[6 / 12, 6 / 12]}>
            {socials.map(social => (
              <a
                aria-label={social.title}
                href={getLink(social.slug)}
                key={uuidv4()}
              >
                <SocialIcon type={social.title} size="huge" />
              </a>
          ))}
          </SocialColumn>
        </LanguageRow>
        <Line color="orange" />
        <FootRow wide>
          <FootRowInner>
            <WordmarkColumn width={1 / 12}>
              <Wordmark src="/images/nonsolus-elsevier-128px.svg" alt="Elsevier wordmark" width="65" />
            </WordmarkColumn>
            <FootTextColumn width={10 / 12}>
              <div>
                {support.map(item => (
                  <FootLinkText
                    text={item.title}
                    to={item.slug}
                    target="_blank"
                    type="extraSmall"
                    underline
                    color={'#000'}
                    key={uuidv4()}
                  />
              ))}
              </div>
              <CookieRow>
                <Text
                  type="bodyXs"
                  text={content.cookie.text}
                  color="grey4"
                />
                <button id="ot-sdk-btn" type="button" className="ot-sdk-show-settings">
                  {' '}
                  { content.cookie.buttonText }                   
                  {' '}
                </button>
              </CookieRow>
              <div>
                <Text
                  type="bodyXs"
                  text={content.copyright}
                  color="grey4"
                />
              </div>
              <AddressRow>
                <Text
                  type="bodyXs"                  
                  color="grey4"
                  dangerouslySetInnerHTML={{__html: content.address }}
                />
              </AddressRow>
              <div>
                <FootLinkText
                  text="京ICP备20031023号-7"
                  to="https://beian.miit.gov.cn/"
                  target="_blank"
                  type="extraSmall"
                  underline
                  color={'petrolBlue'}
                />
                <BeianIco src="https://webapps.elsevier.cn/www/beian_icon.png" alt="RELX logo" />
                <FootLinkText
                  text="京公网安备11010102006133号"
                  to="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102006133"
                  target="_blank"
                  type="extraSmall"
                  underline
                  color={'petrolBlue'}
                />
              </div>
            </FootTextColumn>
            <WordmarkColumn width={1 / 12}>
              <RelxGroup src="/images/relx-no-group.svg" alt="RELX logo" />
            </WordmarkColumn>
          </FootRowInner>
        </FootRow>
      </>
  )


export default Footer
